#import "../fragments/multi-page-form-fragment.graphql"

mutation UpdateMultiPageForm($input: FormUpdateInput!) {
    formUpdate(input: $input) {
        form {
            ...MultiPageFormFragment
        }
    }
}
